module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "contactUs"
    }
  }, [_c('h2', [_vm._v(" Contactar-nos ")]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "El teu email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Subjecte"
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('textarea', {
    staticClass: "textarea",
    attrs: {
      "type": "textarea",
      "rv-model": "message"
    }
  }), _vm._v(" "), (_vm.visibleSendButton) ? _c('a', {
    attrs: {
      "href": _vm.mailto,
      "target": "_blank"
    }
  }, [_vm._v("Enviar email")]) : _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c0b2b7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cat/ContactUs.vue
// module id = 129
// module chunks = 0